import { render, staticRenderFns } from "./ConsolidacionNotas.vue?vue&type=template&id=b55665a6&"
import script from "./ConsolidacionNotas.vue?vue&type=script&lang=js&"
export * from "./ConsolidacionNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports